import React, { Component } from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";
import { api } from "../../_services";

import "./index.css";

class DashboardDeviceHealth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      listLoading: true,
      listLoading2: true,
    };
  }

  componentDidMount = () => {
    if (this.props.currentPrecinct) {
      if (this.props.currentPrecinct.id !== 0) {
        this.getdeviceHealth({ "precinct": this.props.currentPrecinct.id });
      } else {
        this.getdeviceHealth({});
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.currentPrecinct !== nextProps.currentPrecinct && nextProps.currentPrecinct) {
      if (nextProps.currentPrecinct.id !== 0) {
        this.getdeviceHealth({ "precinct": nextProps.currentPrecinct.id });
      } else {
        this.getdeviceHealth({});
      }
    } else if (this.props.reloadCount !== nextProps.reloadCount) {
      if (this.props.currentPrecinct.id !== 0) {
        this.getdeviceHealth({ "precinct": nextProps.currentPrecinct.id });
      } else {
        this.getdeviceHealth({});
      }
    }
  }

  /* Retrieve device health by precincts */
  getdeviceHealth = p => {
    this.setState(() => {
      return {
        listLoading2: true,
      };
    });
    const url = "/api/v1/stats/device_health/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
    }
    const errorMsg = "Unable to retrieve device health.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      this.setState(() => {
        return {
          data: json,
          listLoading: false,
          listLoading2: false,
        };
      });
    });
  };

  getStyle = (color) => {
    return {
      color: color,
    };
  }

  getPercentage = (value, total) => {
    const ValuePercentage = parseFloat(((value / total) * 100).toFixed(1));
    return isNaN(ValuePercentage) ? "--%" : ValuePercentage + "%";
  }

  setDeviceCoverage = (value) => {
    if (isNaN(value)) {
      return "--";
    } else {
      return (value * 100).toFixed(1) + "%";
    }
  }

  render() {
    const { configList } = this.props;
    const { data, listLoading, listLoading2 } = this.state;
    if (!configList) {
      return null;
    }

    if (!data || listLoading) {
      return (
        <Panel className="panel-length deviceHealth">
          <div className="loading2" />
        </Panel>
      );
    }
    const {
      device_count,
      devices_covered_by_alerting_rules,
      devices_by_telemetry_status,
      telemetry_coverage_seven_day
    } = data.current;
    const precinctsLink =
      (this.props.currentPrecinct && this.props.currentPrecinct.id) ?
        "?precincts=" + this.props.currentPrecinct.id : "";
    return (
      <Panel className="panel-length deviceHealth">
        <div className="panel-title">
          Device health {listLoading2 && <FontAwesome className="loadingIcon" name="spinner" spin />}
        </div>
        <div className="panel-body">
          <div className="deviceHealthItem">
            <Link to={"/devices" + precinctsLink}>
              <div className="title">Devices reporting</div>
              <div className="alertCon">{devices_by_telemetry_status.online}/{device_count - devices_by_telemetry_status.unknown}</div>
            </Link>
            {/*<small>{devices_by_telemetry_status.unknown} unmonitored</small>*/}
          </div>
          <div className="deviceHealthItem">
            <Link to={"/devices" + precinctsLink}>
              <div className="title">Device data coverage</div>
              <div className="alertCon">{this.setDeviceCoverage(telemetry_coverage_seven_day)}</div>
            </Link>
          </div>
          <div className="deviceHealthItem">
            <div className="title">Alerting rule coverage</div>
            <div className="alertCon">
              {this.getPercentage(devices_covered_by_alerting_rules, device_count)}
            </div>
          </div>
        </div>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  return {
    configList,
    user,
  };
}

export default connect(mapStateToProps)(DashboardDeviceHealth);



// WEBPACK FOOTER //
// ./src/_components/DashboardDeviceHealth/index.js